/**
 * Oblicza odległość między dwoma punktami geograficznymi używając formuły Haversine
 * @param lat1 - szerokość geograficzna pierwszego punktu
 * @param lon1 - długość geograficzna pierwszego punktu
 * @param lat2 - szerokość geograficzna drugiego punktu
 * @param lon2 - długość geograficzna drugiego punktu
 * @returns odległość w kilometrach
 */
export function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371; // Promień Ziemi w kilometrach
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return Math.round(distance * 10) / 10; // Zaokrąglij do 0.1 km
}

function toRad(degrees: number): number {
  return degrees * (Math.PI / 180);
}
